import { render } from "./CustomerLoginStatisticsView.vue?vue&type=template&id=05fe1656&scoped=true"
import script from "./CustomerLoginStatisticsView.vue?vue&type=script&lang=js"
export * from "./CustomerLoginStatisticsView.vue?vue&type=script&lang=js"

import "./CustomerLoginStatisticsView.vue?vue&type=style&index=0&id=05fe1656&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05fe1656"]])

export default __exports__